.container {
  position: relative;
  display: inline-block;
}

.button {
  border: 0;
  background-color: inherit;
  line-height: 1;
  padding: 0;
  margin-right: 0.5em;

  &:focus {
    outline: 0;
  }
}

.content {
  position: absolute;
  top: 3em;
  padding: 0.5em;
  border: 1px solid var(--blue);
  border-radius: 5px;
  box-shadow: 0 0 2px;
  background-color: var(--white);
  z-index: 4;
  line-height: 1.7;
  font-size: 1rem;
  font-weight: 300;
  min-width: 13em;
  overflow-wrap: break-word;

  &::before {
    content: '';
    position: absolute;
    top: -20px;
    border: 10px solid transparent;
    border-bottom-color: var(--blue);
  }

  &::after {
    content: '';
    position: absolute;
    top: -16px;
    border: 8px solid transparent;
    border-bottom-color: var(--white);
  }
}

.left {
  left: -10px;

  &::before {
    left: 5px;
  }

  &::after {
    left: 7px;
  }
}

.right {
  right: 0;

  &::before {
    right: 5px;
  }

  &::after {
    right: 7px;
  }
}
